import api from "./api";
import axios from "axios";
import versioniSottoProgettiManager from "./SottoProgettiVersione";

class DocumentiFornitoreManager {

    documentiFornitore(config?: any) {
        return api.get(`/documenti_fornitore`, config)
    }

    documentoFornitore(documento_id: number | string, config?: any) {
        return api.get(`/documenti_fornitore/${documento_id}`, config)
    }

    cancellaDocumentoFornitore(documento_id: number | string, config?: any) {
        return api.delete(`/documenti_fornitore/${documento_id}`, config)
    }

    
    retrieve = this.documentoFornitore
    list = this.documentiFornitore
}

const documentiFornitoreManager = new DocumentiFornitoreManager()

export default documentiFornitoreManager
